/**
 * Ajoute automatiquement l'appellation (ex: "Côtes de Provence") sous le nom
 * de chaque vin sur les cartes produit natives (grilles Blancs/Rosés/Rouges).
 * Lit les données depuis quiz-vigneron-data.json — même source que le quiz.
 * S'applique tout seul sur toute la boutique, sans réglage à faire.
 */
(function () {
  var scriptTag = document.currentScript;
  var dataUrl = scriptTag ? scriptTag.dataset.dataUrl : null;
  if (!dataUrl) return;

  var vins = [];

  function applyBadges() {
    var cards = document.querySelectorAll(".product-card");
    cards.forEach(function (card) {
      if (card.querySelector(".pf-appellation")) return; // déjà ajouté

      var titleLink = card.querySelector('[ref="productTitleLink"]');
      if (!titleLink) return;

      var title = titleLink.textContent.trim();
      var vin = vins.find(function (v) {
        return (v.shopify_title || "").trim() === title;
      });
      if (!vin || !vin.appellation) return;

      var el = document.createElement("p");
      el.className = "pf-appellation";
      el.textContent = vin.appellation;
      titleLink.insertAdjacentElement("afterend", el);
    });
  }

  fetch(dataUrl)
    .then(function (res) { return res.json(); })
    .then(function (json) {
      vins = json.vins || [];
      applyBadges();

      // Surveille la page pour les cartes ajoutées après coup
      // (ex: "Vous aimerez aussi", chargé séparément)
      var debounceTimer;
      var observer = new MutationObserver(function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(applyBadges, 150);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    })
    .catch(function () {});
})();